// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. NAD+ refill 09.17.26" (3279462e-cb08-45f7-9093-b333aba8d52b). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiNADRefillAnswerField } from './questions';

export const mdiNADRefill: FormType<mdiNADRefillAnswerField> = {
  name: 'NAD+ refill',
  validityLength: 25,
  questions: [
    'mdiNADRefill_changesMedicalHistorySinceLast',
    'mdiNADRefill_newAllergiesSinceLastPrescription',
    'mdiNADRefill_diagnosedCancerSinceLastPrescription',
    'mdiNADRefill_diagnosedLiverKidneyDiseaseSince',
    'mdiNADRefill_erVisitsHospitalizationsSinceLast',
    'mdiNADRefill_havingSideEffectsCurrentTreatment',
    'mdiNADRefill_describeExperienceCurrentNadDosage',
    'mdiNADRefill_importantClickAttachedLinkReview',
    'mdiNADRefill_messageDoctorLetThemKnow',
    'mdiNADRefill_complete'
  ]
};
